
import * as Highcharts from "highcharts";
import g from "../../globals/variables";

const SalarySurvey = (target) => {
  // * SalarySurveyCalculator.cshtml
  // * SalarySurveyCalculatorController.cs

  const method = {
    init: () => {
      if (target) {
        const form = target;

        form.addEventListener("submit", (e) => {
          e.preventDefault();
          method.submit(form);
        });
      }
    },

    submit: async (form) => {
      const button = form.querySelector("button[type=submit]");
      const callout = form.querySelector(".callout");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      if (callout) {
        callout.remove();
      }

      button.disabled = true;
      button.classList.add("button--loading");

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then(res => res.json())
        .then((response) => {

          if (response.success) {
            method.renderMessage(form, response);
            method.renderCharts(form, response);
            button.classList.remove("button--loading");
            button.disabled = false;
          } else {
            method.renderError(form, response.message, "error");
            button.classList.remove("button--loading");
            button.disabled = false;
          }
        })
        .catch((ex) => {
          console.log(ex);
          button.classList.remove("button--loading");
          button.disabled = false;
          method.renderError(form, `Server error: ${ex}`, "error");
        });
    },

    renderMessage: (form, response) => {
      //const average = form.querySelector(".js-salary-average");
      //const median = form.querySelector(".js-salary-median");
      const lower = form.querySelector(".js-salary-lower");
      const predict = form.querySelector(".js-salary-predict");
      const upper = form.querySelector(".js-salary-upper");
      //const number = form.querySelector(".js-salary-number");
      const results = form.querySelector(".js-salary-result");
      
      lower.innerHTML = `${response.result.Lower.toLocaleString().replace(",", ".").replace(",", ".")} kr.`;
      predict.innerHTML = `${response.result.Pred.toLocaleString().replace(",", ".").replace(",", ".")} kr.`;
      upper.innerHTML = `${response.result.Upper.toLocaleString().replace(",", ".").replace(",", ".")} kr.`;

     results.style.display = "block";
    },

    renderError: (el, message, type) => {
      const results = el.querySelector(".js-salary-result");
      results.style.display = "none";
      el.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },
    
    renderCharts: (form, response) => {
      const chart1 = form.querySelector(".highchart--1");
/*      const chart2 = form.querySelector(".highchart--2");*/

      const salaryType =  dictionary.MP_WA_Basic_Salaries; //dictionary.CSS_Base_Salary/* : window.dictionary.CSS_Total_Salary*/;
      const yearMonth = form.querySelector("[name=yearMonth]").value;
      const year = yearMonth && yearMonth.substring(0, 4);
      const month = yearMonth && parseFloat(yearMonth.substring(4, 6));
      const monthNames = window.dictionary.CSS_Months.split(", ");
      const monthName = yearMonth && monthNames && monthNames[month - 1];

      const chartHeading = `${salaryType}`; // ${window.dictionary.CSS_In} ${monthName} ${year}`;
      const chartSubheading = ` ${response.result.Message}`;  //Var fyrir framan ${window.dictionary.CSS_Comparison} -

      Highcharts.setOptions({
        lang: {
          thousandsSep: ".",
        },
      });
      
      method.renderBarChart(
        response.result.Pred,
        response.result.Lower,
        response.result.Upper,
        response.result.yourSal,        
        chartHeading,
        chartSubheading,
        chart1,
      );

      //const data1 = [];
      //const data2 = [];

      //response.result.forEach((r) => {
      //  data1.push([r.Heildarlaun, parseFloat(r.MidgildiGrunn)]);
      //  data2.push([r.Heildarlaun, parseFloat(r.Grunnlaun)]);
      //});

      //method.renderLineChart(
      //  data1,
      //  data2,
      //  chartHeading,
      //  chartSubheading,
      //  chart2,
      //);

      //if (response.result[0].TinLaun < 20 && response.result[0].TinLaun > 9) {
      //  chart1.insertAdjacentHTML("beforeend", `<p class="highchart__warning">${window.dictionary.CSS_Warning}</p>`);
      //}
    },

    renderBarChart: (series2, series3, series4, series5, heading, subheading, container) => {
      const mobileChartOptions = {
        yAxis: [
          {
            // Primary yAxis
            labels: {
              formatter: function () {
                // Format large numbers to abbreviations
                const number = this.value;
                if (Math.abs(number) >= 1.0e6) {
                  return (number / 1.0e6) + ' mill.';
                } else {
                  return number;
                }
              },
              style: {
                fontSize: '9px',
              },
            },
            title: {
              text: null,
            },
          },
          {
            // Secondary yAxis
            gridLineWidth: 4,
            title: {
              text: " hallós",
            },
            labels: {
              format: "{value} kr.",
            },
            opposite: true,
          },
        ],
      };

      Highcharts.chart(container, {
        chart: {
          type: "column",
        },
        title: {
          style: {
            fontSize: "18px",
            fontWeight: 600,
            color: g.color.blueDark,
          },
          text: heading, // tegundLauna + "laun í " + monthNames[manudur] + " " + ar
        },
        subtitle: {
          text: subheading,
        },
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value: ,.0f} kr.",
            },
            title: {
              text: window.dictionary.CSS_Salary_in_isk, // "Laun í kr.",
            },

            plotLines: [{
              color: g.color.yellow,
              width: 2,
              value: series5
            }]

          },
        ],
        xAxis: {
          categories: [""],
        },
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
        },
        series: [

          {
            type: 'spline',
            name: window.dictionary.MP_WA_Your_Salary, // "Þín laun",
            data: [series5],
            color: g.color.yellow,
          },
          {
            name: `Neðri ${window.dictionary.CSS_Mark}`, // "25% mörk",
            data: [series3],  //3
            color: g.color.blueDark,
          },
          {
            name: window.dictionary.CSS_Salary_Forecast,
            data: [series2],
            color: g.color.blueLight,
          },
          // {
          //   name: `25% ${window.dictionary.CSS_Mark}`, // "25% mörk",
          //   data: [series3],
          //   color: g.color.blueDark,
          // },
          {
            name: `Efri ${window.dictionary.CSS_Mark}`, // "75% mörk",
            data: [series4],
            color: g.color.gray,
          },



        ],
        // MOBILE
        responsive: {
          rules: [{
            condition: {
              maxWidth: 576
            },
            chartOptions: mobileChartOptions,
          }]
        },
      });
    },
  };

  method.init();
};

export default SalarySurvey;
